import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let animStart = window.imageSwapMobileStart;
let animEnd = window.imageSwapMobileEnd;

if(window.innerWidth > 768){
    animStart = window.imageSwapDesktopStart;
    animEnd = window.imageSwapDesktopEnd;
}

ScrollTrigger.create({
    trigger: document.querySelectorAll('.elementor-widget-webien_image_swap'),
    start: "top " + animStart,
    end: "bottom " + animEnd,
    //markers: true,
    onEnter: doAnimation,
    onLeave: reverseAnimation,
    onEnterBack: doAnimation,
    onLeaveBack: reverseAnimation
});


function doAnimation(){

    let img1 = document.querySelector('.image-swap-1');
    let img2 = document.querySelector('.image-swap-2');

    if(!img1 || !img2) return;

    gsap.to(img1, {opacity: 0, scale: 1, duration: 2, ease: 'power4.out',});
    gsap.to(img2, {opacity: 1, scale: 1, duration: 2, ease: 'power4.out',});

}
function reverseAnimation(){

    let img1 = document.querySelector('.image-swap-1');
    let img2 = document.querySelector('.image-swap-2');

    if(!img1 || !img2) return;

    gsap.to(img1, {opacity: 1, scale: 0.6, duration: 2, ease: 'power4.out',});
    gsap.to(img2, {opacity: 0, scale: 0.6, duration: 2, ease: 'power4.out',});

}







